export default __webpack_public_path__ + "static/media/desert.8ee7ddd8.svg";